(function () {
  'use strict';

  var SECTION_ID = 'superbonsai-liver-support-columns';
  var STYLE_ID = 'superbonsai-liver-support-columns-style';
  var BOTTLE_URL = 'https://cdn.shopify.com/s/files/1/0986/4973/5501/files/superbonsai-super-liver-fles_2c3450dc-8ad4-4a75-b57d-755b5d302b34.webp?v=1786043085';

  var COPY = {
    nl: {
      heading: 'Je lever, met dagelijkse ondersteuning',
      left: [
        { title: 'Botanische basis', text: 'Mariadistel, paardenbloem en Yellow Dock vormen de botanische kern van de formule.', icon: 'leaf' },
        { title: 'Aanvullende plantenextracten', text: 'Kurkuma en gember vullen de mix aan binnen een eenvoudige dagelijkse routine.', icon: 'plant' }
      ],
      right: [
        { title: '7 transparant gedoseerde ingrediënten', text: 'Per dagdosering van 2 ml zie je precies hoeveel van ieder ingrediënt de formule bevat.', icon: 'bottle' },
        { title: 'Eenvoudige vloeibare routine', text: 'Twee volle pipetten per dag maken de formule eenvoudig in gebruik.', icon: 'drop' }
      ],
      imageAlt: 'SuperBonsai Super Liver vloeibare druppels'
    },
    de: {
      heading: 'Deine Leber, mit täglicher Unterstützung',
      left: [
        { title: 'Pflanzliche Basis', text: 'Mariendistel, Löwenzahn und Yellow Dock bilden den pflanzlichen Kern der Formel.', icon: 'leaf' },
        { title: 'Ergänzende Pflanzenextrakte', text: 'Kurkuma und Ingwer ergänzen die Mischung für eine einfache tägliche Routine.', icon: 'plant' }
      ],
      right: [
        { title: '7 transparent dosierte Inhaltsstoffe', text: 'Bei jeder Tagesportion von 2 ml ist klar ersichtlich, wie viel von jedem Inhaltsstoff enthalten ist.', icon: 'bottle' },
        { title: 'Einfache flüssige Routine', text: 'Zwei volle Pipetten pro Tag machen die Formel einfach in der Anwendung.', icon: 'drop' }
      ],
      imageAlt: 'SuperBonsai Super Liver flüssige Tropfen'
    },
    en: {
      heading: 'Your liver, with daily support',
      left: [
        { title: 'Botanical foundation', text: 'Milk thistle, dandelion and Yellow Dock form the botanical core of the formula.', icon: 'leaf' },
        { title: 'Complementary plant extracts', text: 'Turmeric and ginger complete the blend as part of a simple daily routine.', icon: 'plant' }
      ],
      right: [
        { title: '7 transparently dosed ingredients', text: 'Each 2 ml daily serving clearly shows how much of every ingredient the formula contains.', icon: 'bottle' },
        { title: 'Simple liquid routine', text: 'Two full droppers per day make the formula easy to use.', icon: 'drop' }
      ],
      imageAlt: 'SuperBonsai Super Liver liquid drops'
    }
  };

  function locale() {
    var lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    return COPY[lang] ? lang : 'en';
  }

  function icon(name) {
    if (name === 'leaf') return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M37 9C24 9 14 14 10 24c-2 7 2 13 9 14 8 1 14-5 16-13 1-5 1-11 2-16Z"/><path d="M15 34c6-8 13-14 20-18"/></svg>';
    if (name === 'plant') return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 38V20"/><path d="M24 27c-7 0-12-4-12-10 7 0 12 4 12 10Z"/><path d="M24 20c7 0 12-4 12-10-7 0-12 4-12 10Z"/><path d="M16 39h16"/></svg>';
    if (name === 'bottle') return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M18 9h12v6H18z"/><path d="M15 15h18v24H15z"/><path d="M19 23h10M19 29h7M19 35h10"/></svg>';
    return '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M24 8c-6 9-12 15-12 23a12 12 0 0 0 24 0c0-8-6-14-12-23Z"/><path d="M18 32c1 3 3 5 7 5"/></svg>';
  }

  function item(feature) {
    return '<div class="sb-liver-columns__feature">' +
      '<div class="sb-liver-columns__hex">' + icon(feature.icon) + '</div>' +
      '<h3>' + feature.title + '</h3>' +
      '<p>' + feature.text + '</p>' +
    '</div>';
  }

  function styles() {
    var old = document.getElementById(STYLE_ID);
    if (old) old.remove();
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '.sb-liver-columns{background:#fbfaf6;color:#102c24;padding:72px 24px 78px;overflow:hidden}',
      '.sb-liver-columns__inner{max-width:1240px;margin:0 auto}',
      '.sb-liver-columns__heading{margin:0 auto 54px;max-width:900px;text-align:center;color:#102c24;font-size:clamp(36px,3.8vw,54px);line-height:1.06;letter-spacing:-.04em;font-weight:700}',
      '.sb-liver-columns__layout{display:grid;grid-template-columns:minmax(0,1fr) minmax(290px,1.05fr) minmax(0,1fr);grid-template-areas:"left bottle right";gap:46px;align-items:center}',
      '.sb-liver-columns__stack{display:grid;gap:48px;align-content:center}',
      '.sb-liver-columns__stack--left{grid-area:left}',
      '.sb-liver-columns__stack--right{grid-area:right}',
      '.sb-liver-columns__feature{text-align:center;max-width:310px;margin:0 auto}',
      '.sb-liver-columns__hex{width:82px;height:74px;margin:0 auto 18px;display:grid;place-items:center;background:#dbeadd;clip-path:polygon(25% 4%,75% 4%,100% 50%,75% 96%,25% 96%,0 50%)}',
      '.sb-liver-columns__hex svg{width:40px;height:40px;fill:none;stroke:#516953;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}',
      '.sb-liver-columns__feature h3{margin:0 0 9px;color:#102c24;font-size:21px;line-height:1.18;letter-spacing:-.015em;font-weight:700}',
      '.sb-liver-columns__feature p{margin:0;color:rgba(16,44,36,.68);font-size:15.5px;line-height:1.55}',
      '.sb-liver-columns__product{grid-area:bottle;display:flex;align-items:center;justify-content:center;min-height:420px}',
      '.sb-liver-columns__product img{display:block;width:min(100%,370px);height:auto;object-fit:contain;filter:none}',
      '@media(max-width:989px) and (min-width:750px){.sb-liver-columns{padding:58px 18px 64px}.sb-liver-columns__heading{margin-bottom:38px;font-size:clamp(32px,4vw,42px)}.sb-liver-columns__layout{grid-template-columns:minmax(190px,1fr) minmax(240px,300px) minmax(190px,1fr);grid-template-areas:"left bottle right";gap:18px;align-items:center}.sb-liver-columns__stack{gap:32px}.sb-liver-columns__feature{max-width:245px}.sb-liver-columns__hex{width:68px;height:62px;margin-bottom:13px}.sb-liver-columns__hex svg{width:33px;height:33px}.sb-liver-columns__feature h3{font-size:18px;margin-bottom:7px}.sb-liver-columns__feature p{font-size:13.5px;line-height:1.45}.sb-liver-columns__product{min-height:350px}.sb-liver-columns__product img{width:min(100%,300px)}}',
      '@media(max-width:749px){.sb-liver-columns{padding:52px 20px 58px}.sb-liver-columns__heading{margin-bottom:32px}.sb-liver-columns__layout{grid-template-columns:1fr;grid-template-areas:"bottle" "left" "right";gap:32px}.sb-liver-columns__product{min-height:300px}.sb-liver-columns__product img{width:min(74vw,305px)}.sb-liver-columns__stack{gap:32px}}',
      '@media(max-width:649px){.sb-liver-columns{padding:46px 18px 52px}.sb-liver-columns__heading{font-size:32px;line-height:1.1;margin-bottom:28px}.sb-liver-columns__layout{gap:30px}.sb-liver-columns__product{min-height:270px;margin-bottom:2px}.sb-liver-columns__product img{width:min(76vw,285px)}.sb-liver-columns__stack{gap:30px}.sb-liver-columns__feature{max-width:360px}.sb-liver-columns__hex{width:74px;height:68px;margin-bottom:15px}.sb-liver-columns__hex svg{width:36px;height:36px}.sb-liver-columns__feature h3{font-size:19px}.sb-liver-columns__feature p{font-size:15px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function isSuperBonsaiPdp() {
    return document.body && document.body.classList.contains('template-product--superbonsai');
  }

  function findTarget() {
    return document.querySelector('[id$="__content_rows"]') || document.querySelector('[id*="__content_rows"]');
  }

  function build() {
    if (!isSuperBonsaiPdp()) return;
    var target = findTarget();
    if (!target) return;
    var t = COPY[locale()];
    var section = document.getElementById(SECTION_ID);
    styles();
    if (!section) {
      section = document.createElement('section');
      section.id = SECTION_ID;
      section.className = 'sb-liver-columns';
      section.setAttribute('data-sb-custom-columns-look', 'true');
      target.parentNode.insertBefore(section, target);
    } else if (section.nextElementSibling !== target) {
      target.parentNode.insertBefore(section, target);
    }
    section.innerHTML = '<div class="sb-liver-columns__inner">' +
      '<h2 class="sb-liver-columns__heading">' + t.heading + '</h2>' +
      '<div class="sb-liver-columns__layout">' +
        '<div class="sb-liver-columns__stack sb-liver-columns__stack--left">' + t.left.map(item).join('') + '</div>' +
        '<div class="sb-liver-columns__product"><img src="' + BOTTLE_URL + '" alt="' + t.imageAlt + '" loading="lazy" width="1200" height="1200"></div>' +
        '<div class="sb-liver-columns__stack sb-liver-columns__stack--right">' + t.right.map(item).join('') + '</div>' +
      '</div>' +
    '</div>';
  }

  function boot() {
    build();
    setTimeout(build, 250);
    setTimeout(build, 900);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', function () { setTimeout(build, 60); });
  document.addEventListener('shopify:section:reorder', function () { setTimeout(build, 60); });
})();
